import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { useQuery, useMutation, useQueryClient } from '@ubisend/pulse-hooks';
import {
  PanelSlider,
  Heading2,
  Divider,
  Placeholder,
  Select,
  Button,
  Flex,
  formatSelectOption,
  useNotification
} from '@ubisend/pulse-components';

import { LicenseSummary, LicensePeriod } from '../Components/index';
import { updateLicense } from '../../../api/index';

const AllClientSelect = ({ value, ...props }) => {
  const query = useQuery({
    queryKey: [
      'owner/clients/all'
    ]
  });

  return (
    <Select
      isClearable
      isLoading={query.isLoading}
      options={query.isSuccess ? query.data.data.map(formatSelectOption) : []}
      value={
        query.isSuccess && value
          ? formatSelectOption(query.data.data.find(({ id }) => value === id))
          : null
      }
      {...props}
    />
  );
};

AllClientSelect.propTypes = {
  value: PropTypes.number
};

const LicenseAccount = ({ id, client: initialClient }) => {
  const [client, setClient] = useState(initialClient ? initialClient.id : null);

  const { showSuccess } = useNotification();

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateLicense,
    onSuccess: () => {
      showSuccess('Successfully updated license.');
      queryClient.invalidateQueries('owner/clients');
      queryClient.invalidateQueries('owner/licenses');
      queryClient.invalidateQueries('owner/licenses/summary');
    }
  });

  const handleClientChange = option => {
    setClient(option ? option.value : null);
  };

  const handleSubmit = event => {
    event.preventDefault();

    if (mutation.isPending) {
      return;
    }

    mutation.mutate({ id, client_id: client });
  };

  return (
    <>
      <Heading2>Attached Account</Heading2>
      <form onSubmit={handleSubmit}>
        <Flex col ySpace>
          <AllClientSelect
            aria-label="Attached account"
            value={client}
            onChange={handleClientChange}
          />
          <Flex right>
            <Button
              loading={mutation.isPending}
              type="submit"
              variant="primary">
              Save
            </Button>
          </Flex>
        </Flex>
      </form>
    </>
  );
};

LicenseAccount.propTypes = {
  id: PropTypes.number.isRequired,
  client: PropTypes.shape({
    id: PropTypes.number
  })
};

const License = ({ match }) => {
  const query = useQuery({
    queryKey: [
      `owner/licenses/${match.params.id}`
    ]
  });

  const history = useHistory();

  const handleHide = () => {
    history.push('/owner/licenses');
  };

  return (
    <PanelSlider width="400px" header="Manage License" handleHide={handleHide}>
      {query.isLoading && <Placeholder />}
      {query.isSuccess && (
        <>
          <LicenseSummary {...query.data.data} />
          <Divider fullWidth />
          <LicenseAccount {...query.data.data} />
          <Divider fullWidth />
          <Heading2>History</Heading2>
          {query.data.data.periods.map((period, key) => (
            <LicensePeriod
              key={key}
              index={key}
              period={period}
              periods={query.data.data.periods}
            />
          ))}
        </>
      )}
    </PanelSlider>
  );
};

export default License;
